import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { APP_ENV } from '../tokens/app-environment.token';
import type { NoticeListResponse } from './notices.models';

/** HTTP only — visible notices for the app shell banner. */
@Injectable({ providedIn: 'root' })
export class NoticesApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(APP_ENV);

  listNotices(): Observable<NoticeListResponse> {
    return this.http.get<NoticeListResponse>(`${this.env.apiBaseUrl}/notices`);
  }
}
